import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const defaultDocumentTitle = msg`Stylion Resume Builder | Create ATS-Friendly Resumes in Minutes`;
const defaultDocumentDescription = msg`Build a professional, ATS-optimized resume in minutes with AI. 11 specialized AI agents help you craft the perfect resume. Join 6M+ users. Free to start!`;
const defaultDocumentKeywords = msg`resume builder, AI resume, ATS optimization, CV maker, job application, career tools, resume templates, professional resume, AI writing assistant`;
const defaultOgTitle = msg`AI Resume Builder | Land Your Dream Job Faster`;
const defaultOgDescription = msg`Create ATS-friendly resumes with 11 AI agents. Professional templates, instant formatting. Join 6M+ users who got hired!`;
const defaultTwitterDescription = msg`Create ATS-friendly resumes with 11 AI agents. Join 6M+ users!`;

const OG_IMAGE_PATH = "/og-image.jpg";

/**
 * Default SEO + social tags for the SPA shell. Routes that render their own
 * <Helmet> (e.g. home) override these. Strings follow the active Lingui locale.
 */
export function DocumentLocalizedMeta() {
  const { i18n } = useLingui();
  const { pathname } = useLocation();

  const title = i18n._(defaultDocumentTitle);
  const description = i18n._(defaultDocumentDescription);
  const keywords = i18n._(defaultDocumentKeywords);
  const ogTitle = i18n._(defaultOgTitle);
  const ogDescription = i18n._(defaultOgDescription);
  const twitterDescription = i18n._(defaultTwitterDescription);

  const pageUrl = `https://ai.stylion.io${pathname}`;
  const ogLocale = i18n.locale.replace(/-/g, "_");
  const fullImageUrl = `https://ai.stylion.io${OG_IMAGE_PATH}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Stylion" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:locale" content={ogLocale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="twitter:image" content={fullImageUrl} />
    </Helmet>
  );
}
